export const append = (enumerable, value) => {
  // eslint-disable-line import/prefer-default-export
  const typeOfEnumerable = typeof enumerable;
  const typeOfValue = typeof value;

  if (Array.isArray(enumerable)) {
    return [...enumerable, value];
  }

  if (typeOfEnumerable === 'object') {
    return typeOfValue === 'object' && value !== null
      ? { ...enumerable, ...value }
      : enumerable;
  }

  if (typeOfEnumerable === 'undefined') {
    return [value];
  }

  throw new Error(`Type of "${typeOfEnumerable}" is not supported.`);
};
